import * as React from 'react';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { X } from 'lucide-react';

// Non-modal side sheet — the DataTable behind stays fully interactive.
// Uses Radix Dialog with `modal={false}` and NO overlay, so users can click
// through to sort/filter/open another row while the detail sheet is open.

export function SideSheet({ open, onOpenChange, children, width = 420, testId = 'side-sheet' }) {
    return (
        <DialogPrimitive.Root open={open} onOpenChange={onOpenChange} modal={false}>
            <DialogPrimitive.Portal>
                <DialogPrimitive.Content
                    data-testid={testId}
                    aria-describedby={undefined}
                    onInteractOutside={(e) => e.preventDefault()}
                    onPointerDownOutside={(e) => e.preventDefault()}
                    style={{ width: `${width}px` }}
                    className="fixed inset-y-0 right-0 z-40 max-w-full bg-white border-l border-[#E5E7EB] shadow-xl flex flex-col outline-none
                                data-[state=open]:animate-in data-[state=closed]:animate-out
                                data-[state=open]:slide-in-from-right data-[state=closed]:slide-out-to-right
                                data-[state=open]:duration-300 data-[state=closed]:duration-200"
                >
                    <DialogPrimitive.Title className="sr-only">Détail</DialogPrimitive.Title>
                    {children}
                </DialogPrimitive.Content>
            </DialogPrimitive.Portal>
        </DialogPrimitive.Root>
    );
}

export function SideSheetCloseButton({ onClose, testId = 'side-sheet-close' }) {
    return (
        <button
            type="button"
            data-testid={testId}
            onClick={onClose}
            className="w-8 h-8 rounded-md inline-flex items-center justify-center text-[#6B7280] hover:bg-[#F5F6FA]"
            aria-label="Fermer"
        >
            <X size={18} strokeWidth={1.75} />
        </button>
    );
}
